import React from 'react';
import PropTypes from 'prop-types';
import { CopilotIcon } from '@bingads-webui-theme-2018/embeded-svgs';
import { createToolbarButton } from './utilities';


const CopilotButtonEmbeded = createToolbarButton(['global-menu-copilot-dropdown-toggle']);

export const CopilotButton = React.memo(({
  i18n,
  ...others
}) => {
  const text = i18n.getString(_TL_('Copilot'));
  const svgicon = <CopilotIcon />;

  return (<CopilotButtonEmbeded {...others} text={text} svgicon={svgicon} />);
});

CopilotButton.defaultProps = {
};

CopilotButton.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
};
